import csrf from "./csrf";

export default {
    data() {
        return {
            contentTypes: {
                Author: {
                    columnSelector: "full_name",
                    routeKeyName: "slug",
                    updateRouteName: "api.authors.update",
                    editRouteName: "authors.edit",
                    formRoute: route("api.authors.store"),
                    listRoute: route("api.authors.index"),
                },
                Blog: {
                    columnSelector: "name",
                    updateRouteName: "api.blogs.update",
                    editRouteName: "blogs.edit",
                    formRoute: route("api.blogs.store"),
                    listRoute: route("api.blogs.index"),
                },
                Guide: {
                    columnSelector: "name",
                    updateRouteName: "api.guides.update",
                    editRouteName: "guides.edit",
                    formRoute: route("api.guides.store"),
                    listRoute: route("api.guides.index"),
                },
                "Fact Checked By": {
                    columnSelector: "full_name",
                    routeKeyName: "slug",
                    updateRouteName: "api.authors.update",
                    editRouteName: "authors.edit",
                    formRoute: route("api.authors.store"),
                    listRoute: route("api.authors.index"),
                },
                FAQ: {
                    columnSelector: "heading",
                    updateRouteName: "api.faqs.update",
                    editRouteName: "faqs.edit",
                    formRoute: route("api.faqs.store"),
                    listRoute: route("api.faqs.index"),
                },
                Testimonial: {
                    columnSelector: "title",
                    updateRouteName: "api.testimonials.update",
                    editRouteName: "testimonials.edit",
                    formRoute: route("api.testimonials.store"),
                    listRoute: route("api.testimonials.index"),
                },
                "Trust Checker": {
                    columnSelector: "name",
                    updateRouteName: "api.trustCheckers.update",
                    editRouteName: "trustCheckers.edit",
                    formRoute: route("api.trustCheckers.store"),
                    listRoute: route("api.trustCheckers.index"),
                },
                "Jump Navi With Author Quote": {
                    columnSelector: "name",
                    updateRouteName: "api.jumpNaviWithAuthorQuotes.update",
                    formRoute: route("api.jumpNaviWithAuthorQuotes.store"),
                    listRoute: route("api.jumpNaviWithAuthorQuotes.index"),
                },
                License: {
                    columnSelector: "name",
                    updateRouteName: "api.licenses.update",
                    editRouteName: "licenses.edit",
                    formRoute: route("api.licenses.store"),
                    listRoute: route("api.licenses.index"),
                },
                Tag: {
                    columnSelector: "name",
                    updateRouteName: "api.tags.update",
                    editRouteName: "tags.edit",
                    formRoute: route("api.tags.store"),
                    listRoute: route("api.tags.index"),
                },
                Role: {
                    columnSelector: "name",
                    updateRouteName: "api.roles.update",
                    editRouteName: "roles.edit",
                    formRoute: route("api.roles.store"),
                    listRoute: route("api.roles.index"),
                },
                Right: {
                    columnSelector: "name",
                    updateRouteName: "api.rights.update",
                    formRoute: route("api.rights.store"),
                    listRoute: route("api.rights.index"),
                },
                "Jump Link": {
                    columnSelector: "name",
                    listRoute: route("api.jumpLinks.index"),
                },
                Country: {
                    columnSelector: "name",
                    updateRouteName: "api.countries.update",
                    editRouteName: "countries.edit",
                    formRoute: route("api.countries.store"),
                    listRoute: route("api.countries.index"),
                },
                Casino: {
                    columnSelector: "name",
                    updateRouteName: "api.casinos.update",
                    editRouteName: "casinos.edit",
                    formRoute: route("api.casinos.store"),
                    listRoute: route("api.casinos.index"),
                },
                "Game Type": {
                    columnSelector: "name",
                    updateRouteName: "api.gameTypes.update",
                    editRouteName: "gameTypes.edit",
                    formRoute: route("api.gameTypes.store"),
                    listRoute: route("api.gameTypes.index"),
                },
                "All Category": {
                    columnSelector: "name",
                    updateRouteName: "api.categories.update",
                    editRouteName: "categories.edit",
                    formRoute: route("api.categories.store"),
                    listRoute: route("api.allCategories.index"),
                },
                Category: {
                    columnSelector: "name",
                    updateRouteName: "api.categories.update",
                    editRouteName: "categories.edit",
                    formRoute: route("api.categories.store"),
                    listRoute: route("api.categories.index"),
                },
                "Software Category": {
                    columnSelector: "software.name",
                    updateRouteName: "api.softwareCategories.update",
                    editRouteName: "softwareCategories.edit",
                    formRoute: route("api.softwareCategories.store"),
                    listRoute: route("api.softwareCategories.index"),
                },
                "Country Category": {
                    columnSelector: "country.name",
                    updateRouteName: "api.countryCategories.update",
                    editRouteName: "countryCategories.edit",
                    formRoute: route("api.countryCategories.store"),
                    listRoute: route("api.countryCategories.index"),
                },
                "Payment Category Home": {
                    columnSelector: "payment_method.name",
                    updateRouteName: "api.paymentCategories.update",
                    editRouteName: "paymentCategories.edit",
                    formRoute: route("api.paymentCategories.store"),
                    listRoute: route("api.paymentCategories.index"),
                },
                "Payment Category": {
                    columnSelector: "name",
                    updateRouteName: "api.paymentCategories.update",
                    editRouteName: "paymentCategories.edit",
                    formRoute: route("api.paymentCategories.store"),
                    listRoute: route("api.paymentCategories.index"),
                },
                "License Category": {
                    columnSelector: "name",
                    updateRouteName: "api.licenseCategories.update",
                    editRouteName: "licenseCategories.edit",
                    formRoute: route("api.licenseCategories.store"),
                    listRoute: route("api.licenseCategories.index"),
                },
                "Bonus Type Category": {
                    columnSelector: "name",
                    updateRouteName: "api.bonusTypeCategories.update",
                    editRouteName: "bonusTypeCategories.edit",
                    formRoute: route("api.bonusTypeCategories.store"),
                    listRoute: route("api.bonusTypeCategories.index"),
                },
                "Game Type Category": {
                    columnSelector: "name",
                    updateRouteName: "api.gameTypeCategories.update",
                    editRouteName: "gameTypeCategories.edit",
                    formRoute: route("api.gameTypeCategories.store"),
                    listRoute: route("api.gameTypeCategories.index"),
                },
                "Company Behind Category": {
                    columnSelector: "name",
                    updateRouteName: "api.companyBehindCategories.update",
                    editRouteName: "companyBehindCategories.edit",
                    formRoute: route("api.companyBehindCategories.store"),
                    listRoute: route("api.companyBehindCategories.index"),
                },
                Device: {
                    columnSelector: "name",
                    updateRouteName: "api.devices.update",
                    editRouteName: "devices.edit",
                    formRoute: route("api.devices.store"),
                    listRoute: route("api.devices.index"),
                },
                "Sticky-C-T-A": {
                    columnSelector: "name",
                    updateRouteName: "api.stickyCTAs.update",
                    editRouteName: "stickyCTAs.edit",
                    formRoute: route("api.stickyCTAs.store"),
                    listRoute: route("api.stickyCTAs.index"),
                },
                "Payment Method": {
                    columnSelector: "name",
                    updateRouteName: "api.paymentMethods.update",
                    editRouteName: "paymentMethods.edit",
                    formRoute: route("api.paymentMethods.store"),
                    listRoute: route("api.paymentMethods.index"),
                },
                TableTemplate: {
                    columnSelector: "name",
                    updateRouteName: "api.tableTemplates.update",
                    editRouteName: "tableTemplates.edit",
                    formRoute: route("api.tableTemplates.store"),
                    listRoute: route("api.tableTemplates.index"),
                },
                Cluster: {
                    columnSelector: "name",
                    updateRouteName: "api.clusters.update",
                    editRouteName: "clusters.edit",
                    formRoute: route("api.clusters.store"),
                    listRoute: route("api.clusters.index"),
                },
                Slot: {
                    columnSelector: "name",
                    updateRouteName: "api.slots.update",
                    editRouteName: "slots.edit",
                    formRoute: route("api.slots.store"),
                    listRoute: route("api.slots.index"),
                },
                Game: {
                    columnSelector: "name",
                    updateRouteName: "api.games.update",
                    editRouteName: "games.edit",
                    formRoute: route("api.games.store"),
                    listRoute: route("api.games.index"),
                },
                "Affiliate Link": {
                    columnSelector: "name",
                    updateRouteName: "api.affiliateLinks.update",
                    editRouteName: "affiliateLinks.edit",
                    formRoute: route("api.affiliateLinks.store"),
                    listRoute: route("api.affiliateLinks.index"),
                },
                Media: {
                    columnSelector: "url",
                },
                Ranking: {
                    columnSelector: "name",
                    updateRouteName: "api.rankings.update",
                    editRouteName: "rankings.edit",
                    formRoute: route("api.rankings.store"),
                    listRoute: route("api.rankings.index"),
                },
                "Slot Ranking": {
                    columnSelector: "name",
                    updateRouteName: "api.slotRankings.update",
                    editRouteName: "slotRankings.edit",
                    formRoute: route("api.slotRankings.store"),
                    listRoute: route("api.slotRankings.index"),
                },
                Status: {
                    columnSelector: "name",
                    listRoute: route("api.statuses.index"),
                },
                "Payout Ratio": {
                    columnSelector: "name",
                    listRoute: route("api.payoutRatios.index"),
                },
                "Menu Document": {
                    columnSelector: "name",
                    editRouteName: "api.documents.edit",
                    listRoute: route("api.documents.index"),
                },
                "Menu Top Choice": {
                    columnSelector: "casino_review.name",
                    updateRouteName: "api.menuTopChoices.update",
                    deleteRouteName: "api.menuTopChoices.delete",
                    formRoute: route("api.menuTopChoices.store"),
                    listRoute: route("api.menuTopChoices.index"),
                },
                "Page Document": {
                    columnSelector: "name",
                    listRoute: route("api.documents.index"),
                },
                "Pros and Cons": {
                    columnSelector: "name",
                    updateRouteName: "api.prosAndConsLists.update",
                    editRouteName: "prosAndConsLists.edit",
                    formRoute: route("api.prosAndConsLists.store"),
                    listRoute: route("api.prosAndConsLists.index"),
                },
                Meta: {
                    columnSelector: "name",
                    updateRouteName: "api.metas.update",
                    editRouteName: "metas.edit",
                    formRoute: route("api.metas.store"),
                    listRoute: route("api.metas.index"),
                },
                "Bonus Type": {
                    columnSelector: "name",
                    updateRouteName: "api.bonusTypes.update",
                    editRouteName: "bonusTypes.edit",
                    formRoute: route("api.bonusTypes.store"),
                    listRoute: route("api.bonusTypes.index"),
                },
                Event: {
                    columnSelector: "name",
                    updateRouteName: "api.events.update",
                    editRouteName: "events.edit",
                    formRoute: route("api.events.store"),
                    listRoute: route("api.events.index"),
                },
                Bonus: {
                    columnSelector: "name",
                    updateRouteName: "api.bonuses.update",
                    editRouteName: "bonuses.edit",
                    formRoute: route("api.bonuses.store"),
                    listRoute: route("api.bonuses.index"),
                },
                "Casino Language": {
                    columnSelector: "name",
                    updateRouteName: "api.casinoLanguages.update",
                    editRouteName: "casinoLanguages.edit",
                    formRoute: route("api.casinoLanguages.store"),
                    listRoute: route("api.casinoLanguages.index"),
                },
                "Slot Type": {
                    columnSelector: "name",
                    updateRouteName: "api.slotTypes.update",
                    editRouteName: "slotTypes.edit",
                    formRoute: route("api.slotTypes.store"),
                    listRoute: route("api.slotTypes.index"),
                },
                Software: {
                    columnSelector: "name",
                    updateRouteName: "api.software.update",
                    editRouteName: "software.edit",
                    formRoute: route("api.software.store"),
                    listRoute: route("api.software.index"),
                },
                "Slot Software Type": {
                    columnSelector: "name",
                    updateRouteName: "api.slotSoftwareTypes.update",
                    editRouteName: "slotSoftwareTypes.edit",
                    formRoute: route("api.slotSoftwareTypes.store"),
                    listRoute: route("api.slotSoftwareTypes.index"),
                },
                Currency: {
                    columnSelector: "name",
                    updateRouteName: "api.currencies.update",
                    editRouteName: "currencies.edit",
                    formRoute: route("api.currencies.store"),
                    listRoute: route("api.currencies.index"),
                },
                State: {
                    columnSelector: "name",
                    updateRouteName: "api.states.update",
                    editRouteName: "api.states.edit",
                    formRoute: route("api.states.store"),
                    listRoute: route("api.states.index"),
                },
                "Slot Review": {
                    columnSelector: "name",
                    updateRouteName: "api.slotReviews.update",
                    editRouteName: "slotReviews.edit",
                    formRoute: route("api.slotReviews.store"),
                    listRoute: route("api.slotReviews.index"),
                },
                "Game Review": {
                    columnSelector: "name",
                    updateRouteName: "api.gameReviews.update",
                    editRouteName: "gameReviews.edit",
                    formRoute: route("api.gameReviews.store"),
                    listRoute: route("api.gameReviews.index"),
                },
                "Casino Review": {
                    columnSelector: "name",
                    updateRouteName: "api.casinoReviews.update",
                    editRouteName: "casinoReviews.edit",
                    formRoute: route("api.casinoReviews.store"),
                    listRoute: route("api.casinoReviews.index"),
                },
                "Company Behind": {
                    columnSelector: "name",
                    updateRouteName: "api.companiesBehind.update",
                    editRouteName: "companiesBehind.edit",
                    formRoute: route("api.companiesBehind.store"),
                    listRoute: route("api.companiesBehind.index"),
                },
                Conversion: {
                    columnSelector: "name",
                    updateRouteName: "api.conversions.update",
                    deleteRouteName: "api.conversions.delete",
                    formRoute: route("api.conversions.store"),
                    listRoute: route("api.conversions.index"),
                },
                "Slot Conversion": {
                    columnSelector: "name",
                    updateRouteName: "api.slotConversions.update",
                    deleteRouteName: "api.slotConversions.delete",
                    formRoute: route("api.slotConversions.store"),
                    listRoute: route("api.slotConversions.index"),
                },
                "Alert Box": {
                    columnSelector: "name",
                    updateRouteName: "api.alertBoxes.update",
                    formRoute: route("api.alertBoxes.store"),
                    listRoute: route("api.alertBoxes.index"),
                },
                "Site Language": {
                    columnSelector: "name",
                    listRoute: route("api.siteLanguages.index"),
                },
                "Internal Link": {
                    columnSelector: "button_text",
                    updateRouteName: "api.internalLinks.update",
                    formRoute: route("api.internalLinks.store"),
                    listRoute: route("api.internalLinks.index"),
                },
                Passion: {
                    columnSelector: "button_anchor_text",
                    updateRouteName: "api.passions.update",
                    formRoute: route("api.passions.store"),
                    listRoute: route("api.passions.index"),
                },
                "Category Tile": {
                    columnSelector: "link.display_label",
                    updateRouteName: "api.categoryTiles.update",
                    formRoute: route("api.categoryTiles.store"),
                    listRoute: route("api.categoryTiles.index"),
                },
                "Game Tile": {
                    columnSelector: "link.display_label",
                    updateRouteName: "api.gameTiles.update",
                    formRoute: route("api.gameTiles.store"),
                    listRoute: route("api.gameTiles.index"),
                },
                "Bonus Tile": {
                    columnSelector: "casino_bonus",
                    updateRouteName: "api.bonusTiles.update",
                    formRoute: route("api.bonusTiles.store"),
                    listRoute: route("api.bonusTiles.index"),
                },
                "Related Topic": {
                    columnSelector: "button_anchor_text",
                    updateRouteName: "api.relatedTopics.update",
                    formRoute: route("api.relatedTopics.store"),
                    listRoute: route("api.relatedTopics.index"),
                },
                "About Us Page": {
                    columnSelector: "name",
                    updateRouteName: "api.aboutUsPages.update",
                    editRouteName: "aboutUsPages.edit",
                    formRoute: route("api.aboutUsPages.store"),
                    listRoute: route("api.aboutUsPages.index"),
                },
                "Payment Method Main Page": {
                    columnSelector: "name",
                    updateRouteName: "api.paymentMethodMainPages.update",
                    editRouteName: "paymentMethodMainPages.edit",
                    formRoute: route("api.paymentMethodMainPages.store"),
                    listRoute: route("api.paymentMethodMainPages.index"),
                },
                "License Main Page": {
                    columnSelector: "name",
                    updateRouteName: "api.licenseMainPages.update",
                    editRouteName: "licenseMainPages.edit",
                    formRoute: route("api.licenseMainPages.store"),
                    listRoute: route("api.licenseMainPages.index"),
                },
                "Knowledge Hub Page": {
                    columnSelector: "name",
                    updateRouteName: "api.knowledgeHubPages.update",
                    editRouteName: "knowledgeHubPages.edit",
                    formRoute: route("api.knowledgeHubPages.store"),
                    listRoute: route("api.knowledgeHubPages.index"),
                },
                "Blog Main Page": {
                    columnSelector: "name",
                    updateRouteName: "api.blogMainPages.update",
                    editRouteName: "blogMainPages.edit",
                    formRoute: route("api.blogMainPages.store"),
                    listRoute: route("api.blogMainPages.index"),
                },
                "Guide Main Page": {
                    columnSelector: "name",
                    updateRouteName: "api.guideMainPages.update",
                    editRouteName: "guideMainPages.edit",
                    formRoute: route("api.guideMainPages.store"),
                    listRoute: route("api.guideMainPages.index"),
                },
                "Trust Page": {
                    columnSelector: "name",
                    updateRouteName: "api.trustPages.update",
                    editRouteName: "trustPages.edit",
                    formRoute: route("api.trustPages.store"),
                    listRoute: route("api.trustPages.index"),
                },
                "Legal Notice Page": {
                    columnSelector: "name",
                    updateRouteName: "api.legalNoticePages.update",
                    editRouteName: "legalNoticePages.edit",
                    formRoute: route("api.legalNoticePages.store"),
                    listRoute: route("api.legalNoticePages.index"),
                },
                "Privacy Policy Page": {
                    columnSelector: "name",
                    updateRouteName: "api.privacyPolicyPages.update",
                    editRouteName: "privacyPolicyPages.edit",
                    formRoute: route("api.privacyPolicyPages.store"),
                    listRoute: route("api.privacyPolicyPages.index"),
                },
                "Cookie Policy Page": {
                    columnSelector: "name",
                    updateRouteName: "api.cookiePolicyPages.update",
                    editRouteName: "cookiePolicyPages.edit",
                    formRoute: route("api.cookiePolicyPages.store"),
                    listRoute: route("api.cookiePolicyPages.index"),
                },
                "Responsible Gambling Page": {
                    columnSelector: "name",
                    updateRouteName: "api.responsibleGamblingPages.update",
                    editRouteName: "responsibleGamblingPages.edit",
                    formRoute: route("api.responsibleGamblingPages.store"),
                    listRoute: route("api.responsibleGamblingPages.index"),
                },
                "How To": {
                    columnSelector: "name",
                    updateRouteName: "api.howTos.update",
                    editRouteName: "howTos.edit",
                    formRoute: route("api.howTos.store"),
                    listRoute: route("api.howTos.index"),
                },
                "Home Page": {
                    columnSelector: "name",
                    updateRouteName: "api.homePages.update",
                    editRouteName: "homePages.edit",
                    formRoute: route("api.homePages.store"),
                    listRoute: route("api.homePages.index"),
                },
                "Html Sitemap": {
                    columnSelector: "name",
                    updateRouteName: "api.htmlSitemaps.update",
                    editRouteName: "htmlSitemaps.edit",
                    formRoute: route("api.htmlSitemaps.store"),
                    listRoute: route("api.htmlSitemaps.index"),
                },
                "Footer Logo": {
                    columnSelector: "media.original_name",
                    updateRouteName: "api.footerLogos.update",
                    formRoute: route("api.footerLogos.store"),
                    listRoute: route("api.footerLogos.index"),
                },
            },
        };
    },
    methods: {
        generateObjectUpdateRoute(object) {
            if (this.editable) {
                const routeName = this.contentTypes[this.model].updateRouteName;
                const columnVal =
                    object[this.contentTypes[this.model].routeKeyName || "id"];
                object.updateRoute = route(routeName, columnVal);
                return object;
            }
            return object;
        },
        generateObjectDeleteRoute(object) {
            if (this.deletable) {
                const routeName = this.contentTypes[this.model].deleteRouteName;
                const columnVal =
                    object[this.contentTypes[this.model].routeKeyName || "id"];
                object.deleteRoute = route(routeName, columnVal);
                return object;
            }
            return object;
        },
        generateObjectEditRoute(object) {
            if (this.shouldOpenNewWindow) {
                const routeName = this.contentTypes[this.model].editRouteName;
                const columnVal =
                    object[this.contentTypes[this.model].routeKeyName || "id"];
                object.deleteRoute = route(routeName, columnVal);
                return object;
            }
            return object;
        },
        getItemLabel(object) {
            const contentType = this.contentTypes[this.model];
            let columnSelector = contentType?.columnSelector ?? "name";
            let label = object[columnSelector];
            if (columnSelector.includes(".")) {
                const relationships = columnSelector.split(".");
                let newObject = object;
                for (let i = 0; i < relationships.length; i++) {
                    newObject = newObject[relationships[i]];
                }
                label = newObject;
            }
            return label;
        },
    },
};
